import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { Text, View, Navigator, } from "../_core/components";
import { TaroEnv } from "../_util/env";
import { useConfig } from "../_util/use-config";
var themeMap = {
    default: "",
    light: "--light",
    disabled: "--disabled",
    primary: "--primary",
    success: "--success",
    warning: "--warning",
    danger: "--danger",
};
export function TypographyText(_a) {
    var _b, _c;
    var _d = _a.theme, theme = _d === void 0 ? "default" : _d, block = _a.block, ellipsis = _a.ellipsis, size = _a.size, className = _a.className, props = __rest(_a, ["theme", "block", "ellipsis", "size", "className"]);
    var classPrefix = useConfig().classPrefix;
    var Parent = block || ellipsis ? View : Text;
    return (React.createElement(Parent, __assign({ className: classNames(classPrefix + "-typography", classPrefix + "-text", classPrefix + "-text" + (themeMap[theme] || ""), (_b = {}, _b["size-" + size] = size, _b), className, (_c = {},
            _c[classPrefix + "-ellipsis"] = ellipsis,
            _c)) }, props)));
}
export function TypographyLink(_a) {
    var _b, _c;
    var size = _a.size, className = _a.className, url = _a.url, children = _a.children, props = __rest(_a, ["size", "className", "url", "children"]);
    var classPrefix = useConfig().classPrefix;
    if (!TaroEnv || TaroEnv === "h5") {
        return (
        // eslint-disable-next-line react/forbid-elements
        React.createElement("a", __assign({ className: classNames(classPrefix + "-typography", classPrefix + "-text", classPrefix + "-text--link", classPrefix + "-link", (_b = {}, _b["size-" + size] = size, _b), className), href: url }, props), children));
    }
    return (React.createElement(Navigator, __assign({ className: classNames(classPrefix + "-typography", classPrefix + "-text", classPrefix + "-text--link", classPrefix + "-link", (_c = {}, _c["size-" + size] = size, _c), className), url: url }, props), children));
}
//# sourceMappingURL=Text.js.map